import React from 'react';
import { FormGroup, Input } from '@tencent/spaui';

const MyInput = (props) => (
  <FormGroup status={props.status}>
    <Input {...props} />
  </FormGroup>
);

export default MyInput;
